// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .fs-4 {
        font-size: 24px !important;
      }
      .fs-6 {
        font-size: 16px !important;
      }
      .breadcrumb-item::before {
        display: none;
      }

      .vertical-separator {
        width: 1px;
        height: 28px;
      }
      .breadcrumb-item,
      .breadcrumb-item + div {
        line-height: 28px;
      }
    `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-page-header/zikata-page-header.component.ts"],"names":[],"mappings":";MACM;QACE,0BAA0B;MAC5B;MACA;QACE,0BAA0B;MAC5B;MACA;QACE,aAAa;MACf;;MAEA;QACE,UAAU;QACV,YAAY;MACd;MACA;;QAEE,iBAAiB;MACnB","sourcesContent":["\n      .fs-4 {\n        font-size: 24px !important;\n      }\n      .fs-6 {\n        font-size: 16px !important;\n      }\n      .breadcrumb-item::before {\n        display: none;\n      }\n\n      .vertical-separator {\n        width: 1px;\n        height: 28px;\n      }\n      .breadcrumb-item,\n      .breadcrumb-item + div {\n        line-height: 28px;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
